import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { ScheduleShift } from '@/entities/Shift/Shift'
import { AsyncReduxState, initialAsyncReduxState } from '@/redux/@config/AsyncReduxState'

export type ShiftsState = AsyncReduxState<{
    scheduleShifts: ScheduleShift[]
}>

const initialState: ShiftsState = {
    scheduleShifts: [],
    ...initialAsyncReduxState,
}

export const ShiftSlice = createSlice({
    name: 'shiftsReducer',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ShiftsState {
            return {
                ...state,
                isLoading: action.payload,
            }
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ShiftsState {
            return {
                ...state,
                isSuccessful: action.payload,
            }
        },
        setError(state, action: PayloadAction<string>): ShiftsState {
            return {
                ...state,
                error: action.payload,
            }
        },
        setScheduleShifts(state, action: PayloadAction<ScheduleShift[]>): ShiftsState {
            return {
                ...state,
                scheduleShifts: action.payload,
            }
        },
    },
})

export const {
    setScheduleShifts,
    setIsLoading,
    setIsSuccessful,
    setError,
} = ShiftSlice.actions

export const shiftsReducer = ShiftSlice.reducer
